import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as reportsActions from './actions/Reports';
import Full from './containers/Full/';
import Login from './views/_Pages/Login/';
import Register from './views/_Pages/Register/';
import Page404 from './views/_Pages/Page404/';
import Page500 from './views/_Pages/Page500/';

const history = createBrowserHistory();

class Root extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { customers } = this.props;
    this.props.loadTranslations();
    if (customers.length === 0) {
      this.props.getCustomers();
    }
  }

  render() {
    const {selectedLocale, translations} = this.props;
    const translation = translations[selectedLocale];
    let children;

    if (translation) {
      children = (
        <HashRouter history={history}>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route path="/" name="Home" component={Full} />
          </Switch>
        </HashRouter>
      );
    }

    return <div>{children}</div>;
  }
}

class RootContainer extends Component {
  render() {
    return <Root
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

RootContainer = connect(state => ({
  customers: state.reports.get('customers'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
  languages: state.reports.get('languages'),
}))(RootContainer);

export default RootContainer;



// WEBPACK FOOTER //
// ./src/Root.js